import React, { useEffect, useRef } from "react";
import Logo from "../ui/logo";
import Link from "next/link";
import { m, AnimatePresence } from "framer-motion";
import { useSingleModal } from "../contexts";
import { siteSettings } from "../data/site-settings";
import HeaderMenu from "./header-menu";
import Hamburger from "./hamburger";
import MobileMenu from "./mobile-menu";
const { site_header } = siteSettings;
import useScrollLock from "@/utils/use-scroll-lock";
import { useRouter } from "next/router";

export default function Header(props) {
  const router = useRouter();
  const navRef = useRef(null);
  const { setShowNavMenu, showNavMenu, toggleNavMenu } = useSingleModal();
  const toggleNav = () => {
    toggleNavMenu();
  };
  useEffect(() => {
    setShowNavMenu(false);
  }, [router?.pathname]);

  // useScrollLock(showNavMenu);

  return (
    <>
      <header
        className={`shadow-slate-300 fixed top-0 md:left-[5vw] z-[99999] md:max-h-[200px] max-h-[86px] bg-white py-1 lg:px-[72px] md:px-12 px-4 md:w-[90vw] w-full flex flex-col justify-around items-center ${
          showNavMenu ? "rounded-b-0" : "rounded-b-[20px]"
        }`}
      >
        <div
          className={`flex w-full max-w-[none] items-center transition-all duration-300 ease py-1 lg:py-0`}
        >
          <div className="flex items-center mx-auto w-full h-full relative justify-between">
            <Logo />
            <HeaderMenu
              data={site_header.menu}
              className="hidden ml-auto lg:flex"
              color="text-white"
            />
            <Link
              href="/contact-us"
              className="lg:block hidden hover:scale-105 transition-all duration-300 ease bg-[#f2f2f2] hover:bg-lightBlue rounded-[8px] text-blue hover:text-white hover:shadow-2xl capitalize font-medium py-3 leading-none px-6 text-[15px] ml-12"
            >
              Contact Us
            </Link>
            <Hamburger />
          </div>
        </div>
        <AnimatePresence mode="wait">
          {showNavMenu && (
            <m.div
              initial={{ height: 0, opacity: 0 }}
              animate={{
                height: showNavMenu ? "auto" : 0,
                opacity: showNavMenu ? 1 : 0,
                transition: {
                  duration: 0.3,
                },
              }}
              exit={{ height: 0, opacity: 0 }}
              ref={navRef}
              className={`fixed md:top-[102px] top-[86px] w-full lg:hidden bg-[#f2f2f2] flex flex-col justify-start items-start overflow-hidden rounded-br-[10px] rounded-bl-[10px]`}
            >
              <MobileMenu isOpen={showNavMenu} />
            </m.div>
          )}
        </AnimatePresence>
      </header>
    </>
  );
}
